export default __webpack_public_path__ + "static/media/video3.e8d92527.mp4";